export default "__VITE_ASSET__vbQfM087__"